import React from "react";
import SearchTips from "./SearchTips";
import HomeCategoryGridView from "./HomeCategoryGridView";
const NoSearchResultsView = () => <div id="search-elastic" className="container expand no-filter container-product-listing" data-sentry-component="NoSearchResultsView" data-sentry-source-file="NoSearchResultsView.tsx">
    <div className="search__wrap">
      <h1 className="page-header search--title">
        Search Results for: &quot;&quot;
      </h1>
    </div>
    <div id="page" className="fixed-go-to-top clears">
      <div id="main" role="main">
        <div id="product_listing" className="ag box ag-grid">
          <div className="padded">
            <p className="page-header">Please enter a search term above.</p>
          </div>
          <SearchTips data-sentry-element="SearchTips" data-sentry-source-file="NoSearchResultsView.tsx" />
        </div>
        <HomeCategoryGridView data-sentry-element="HomeCategoryGridView" data-sentry-source-file="NoSearchResultsView.tsx" />
      </div>
    </div>
  </div>;
export default NoSearchResultsView;